module.exports = __webpack_public_path__ + "static/img/male.a007fdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/toiletMAP/male.png
// module id = IOId
// module chunks = 1